import {useEffect} from "react";
import store from "../../../redux/store";
import {setWebListConfig} from "../../../redux/slices/videoDataSlice";
import {responseValidator} from "../../helpers";
import {get} from "../../../services/apiCaller";
import {API} from "../../../services/services";
import {useAppSelector} from "../../../redux/hooks";
import { shallowEqual } from 'react-redux'

const useWebListConfig = () => {
    const { params, token, isLiveError } = useAppSelector(({ videoData: { params, token, isLiveError } }) => ({ params, token, isLiveError }), shallowEqual);

    useEffect(() => {
        get(async (response: any, status) => {
            if (responseValidator(status)) store.dispatch(setWebListConfig(response.results))
        }, API().web_list_config(), {
            limit: 1000,
            offset: 0
        })
    }, [isLiveError, token, params.id])

}

export default useWebListConfig;